import { KeyValueDiffer, KeyValueDiffers } from "@angular/core";

export class ValueDiffer<K extends string | number, V> {
	static fromKeyValueDiffers<K extends string | number, V>(differs: KeyValueDiffers, src: Record<K, V> | (() => Record<K, V>)): ValueDiffer<K, V> {
		return new ValueDiffer<K, V>(differs.find(this.getSrc(src)).create(), src);
	}
	
	private static getSrc<K extends string | number, V>(src: Record<K, V> | (() => Record<K, V>)): Record<K, V> {
		return typeof src === 'function' ? src() : src;
	}
	
	constructor(private differ: KeyValueDiffer<K, V>,
	            private src: Record<K, V> | (() => Record<K, V>)) {
	}
	
	changes() {
		return this.differ.diff(ValueDiffer.getSrc(this.src));
	}
}